import { render, staticRenderFns } from "./Past.vue?vue&type=template&id=1f05aa28&scoped=true"
import script from "./Past.vue?vue&type=script&lang=js"
export * from "./Past.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f05aa28",
  null
  
)

export default component.exports